<template>
	<div class="qualityenterprise">
		<leftnav class="fl" mkcode="A" itemcode="A-QBNZQY"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox" style="padding-bottom: 1px;">
					<div class="right_boxtitle">
						<span class="fl right_title">企业</span>
						<div class="fl search-box nz-search-box">
							<span class="searchtype">全部内资企业库</span>
							<input type="text" placeholder="请输入企业名称" class="search-input" />
							<button class="search-btn">查询</button>
						</div>
					</div>
					<div class="opport-screen-list1">
						<dl class="opport-screen bdbe">
							<dt class="fl">企业类型</dt>
							<dd class="fl">
								<span v-for="(item, index) in enterinarr"
									@click="routerself('/enterpriseList?type=' + item.type)"
									class="a-screen">{{ item.name }}</span>
								<span class="a-screen current">全部内资企业</span>
								<span class="blueline"></span>
								<span @click="routerself('/forcapEnterprise')" class="a-screen">外资企业</span>
								<span @click="routerself('/foreignEnterprises')" class="a-screen">境外上市企业</span>
								<el-tooltip class="item smartTip-text" effect="light" placement="top-start"><i
										class="el-icon-question listeltootipicon"></i>
									<div slot="content" class="list_tips">
										<p>上市公司：A股上市的公司 </p>
										<p>龙头企业：规模大、投资实力强、在行业内占据优势地位的企业</p>
										<p>创新企业：被专业投资机构认可并成功融资的企业</p>
										<p>优质企业：具有市场竞争优势和持续发展潜力的企业</p>
										<p>外资企业：外商投资的企业</p>
										<p>境外上市企业：在境外证券交易所公开上市的企业</p>
									</div>
								</el-tooltip>
								<video-teaching :type="1"></video-teaching>
							</dd>
						</dl>
					</div>
				</div>

				<div class="whitebox" style="min-height: 160px;">
					<!-- <div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" v-if="!kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
						<p class="fl"   v-if="kwtextsearch">产业大脑为您找到<span 	class="searchnum">{{total}}</span>条【 <span class="orangefont">{{kwtextsearchtext}}</span>】相关企业</p>
						<div :class="exportbtn?'fr enlistexportbtn':'fr enlistexportbtn disable'" 	@click="enlistExport()" v-if="userdata.groupType == 1" v-show="exportnum>0 && enterpristlist.length>0">
							<span>导出数据</span></div>
					</div> -->
					<!-- 多维度分数筛选 全部内资企业删除排序功能-->
					<!-- <ul class="dimensionScreen oh w95mg" v-show="enterpristlist.length>0">
						<li :class="orderField == list.type ?'fl current ':'fl '"   v-for="(list,index) in dimensionList" @click="tablesort(list.type);" v-show="list.name!='融资时间'||searchtype == 2">
							<span 	:class="{'sortname ':true,'current':orderField == list.type,'fz15':list.name.length>5}">{{list.name}}</span>
							<span :class="orderType == 1?'timesorticon up':'timesorticon down'"></span>
						</li>
					</ul> -->
					<div class="enterprise_list_box" v-show="enterpristlist.length != 0">
						<!-- 全部内资企业 -->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>排名</th>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th>
								<th>地区</th>
								<th>企业实力</th>
								<th>编辑</th>
							</tr>
							<tr v-for="(list, index) in enterpristlist">
								<td>{{ (page - 1) * pageSize + index + 1 }}</td>
								<td class="title" @click="routerlinkid('/enterprises', list.stockCode, curindex)">
									{{ list.title }}</td>
								<td class="conpanytags hastag">
									<span class="span-tag" v-for="item in list.notionlist"
										@click="tagrouter('/enterpriseTag', 0, 'notion', item.id, item.name)">{{ item.name }}</span>
								</td>
								<td class="conpanytags notiontags">
									<span class="span-tag" v-for="item in list.taglist"
										@click="tagrouter('/enterpriseTag', 0, 'tag', item.id, item.name)">{{ item.name }}</span>
								</td>
								<td>{{ list.area }}</td>
								<td>{{ list.zs100000 }}</td>
								<td class="collectfont1"><span @click="listToggleCollect(list)">{{ list.collectId ==
									0 ?'加入':'移除'}}<br />目标企业</span></td>
							</tr>
						</table>
					</div>
					<!-- 	<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"	v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div> -->
				</div>
			</div>
			<!-- 导出列表弹框 -->
			<!-- <div class="enlistexportPop" v-show="exportpop">
				<div class="enlistexportPop_box">
					<h5 class="title">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</h5>
					<p class="smtips">单次最多导出500条，每日最多可以导出10次</p>
					<p class="tips">本次可导出<b class="redfont">{{total>500?500:total}}</b>条，今日剩余次数<b class="redfont">{{exportnum}}</b>次</p>
					<span class="determinebtn" @click="exportlistFun()">{{confirmtext}}</span>
					<span class="closebtn" @click="exportpop=false"></span>
				</div>
			</div> -->
		</div>
		<!-- <iframe :src='iframeurl' style="width: 1px;height: 1px;" frameborder="none" id="exportIframe"></iframe> -->

		<!--  <div id="v-step-0">A DOM element on your page. The first step will pop on this element because its ID is 'v-step-0'.</div>
    <div class="v-step-1">A DOM element on your page. The second step will pop on this element because its ID is 'v-step-1'.</div> 
    <div data-v-step="5">A DOM element on your page. The third and final step will pop on this element because its ID is 'v-step-2'.</div> -->

		<v-tour name="myTour" :steps="steps" :theme="myTheme" :options="myOptions"></v-tour>
	</div>
</template>

<script>
export default {
	name: 'testvuetour',
	data() {
		return {
			enterinarr: [
				{ curindex: 1, type: 9, name: "上市公司", tagnum: 10010, },
				{ curindex: 2, type: 1, name: "龙头企业", tagnum: 10010, },
				{ curindex: 3, type: 2, name: "创新企业", tagnum: 3, },
				{ curindex: 4, type: 3, name: "优质企业", tagnum: 10009 },
			], enterpristlist: [],
			steps: [
				{
					target: '.nav',  // We're using document.querySelector() under the hood
					content: `产业招商大脑导航栏，各种功能模块聚集地`,
					header: {
						title: '导航栏',
					},
					params: {
						placement: 'right'
					}
				},
				{
					target: '.search-box',
					content: '搜索框 点击搜索不同企业库内容',
					params: {
						placement: 'top'
					}
				},
				{
					target: '.a-screen.current',
					content: '当前选择的企业类型',
					params: {
						placement: 'left'
					}
				}
			],
			myOptions: {
				useKeyboardNavigation: false,    //不使用←、→和ESC键来导航tour
				startTimeout: 1000,   //1秒后执行
				labels: {
					buttonSkip: '跳过',
					buttonPrevious: '上一步',
					buttonNext: '下一步',
					buttonStop: '关闭'
				},
				highlight: false,
			},
			myTheme: {
				backgroundColor: 'rgb(249, 204, 204)',
				textColor: '#f30',
				arrowSize: 10,
				arrowColor: 'rgb(249, 204, 204)'
			}
		}
	},
	mounted: function () {
		this.$tours['myTour'].start()
	}
}
</script>
